import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

const renderItems = (items, activeCategoryId, onCategoryClick, sectionTitle) =>
  items.map((item) => (
    <button
      type="button"
      key={item.id}
      className={`convocacao-chip convocacao-chip-button ${activeCategoryId === item.id ? "is-active" : ""}`}
      onClick={() => onCategoryClick(item.id)}
      aria-pressed={activeCategoryId === item.id}
      aria-label={`${sectionTitle}: ${item.label}`}
    >
      <span className="convocacao-chip-button-content">
        <span>{item.label}</span>
        <span className="convocacao-chip-selected-icon" aria-hidden="true">
          <i className="feather-check" />
        </span>
      </span>
    </button>
  ));

const renderColumns = (columns, activeCategoryId, onCategoryClick, sectionTitle) => (
  <div className="row g-3 convocacao-category-columns">
    {columns.map((column, index) => (
      <div className="col-12 col-md-6" key={`${column.title || "col"}-${index}`}>
        <div className="d-grid gap-2">
          {renderItems(column.items, activeCategoryId, onCategoryClick, sectionTitle)}
        </div>
      </div>
    ))}
  </div>
);

const buildColoColumns = (items) => {
  if (items.length === 0) {
    return [
      { title: "Insatisfatórios", items: [] },
      { title: "Alterados", items: [] },
    ];
  }

  return [
    { title: "InsatisfatóriosS", items: [items[0]] },
    { title: "Alterados", items: items.slice(1) },
  ];
};

const buildMamaColumns = (items) => {
  const midpoint = Math.ceil(items.length / 2);
  return [
    { title: "", items: items.slice(0, midpoint) },
    { title: "", items: items.slice(midpoint) },
  ];
};

const renderBlock = (title, columns, activeCategoryId, onCategoryClick) => (
  <div className="col-12 col-lg-6">
    <section className="convocacao-category-box h-100" aria-label={title}>
      <h6 className="mb-3 convocacao-category-title">{title}</h6>
      {columns.some((column) => column.items.length > 0) ? (
        renderColumns(columns, activeCategoryId, onCategoryClick, title)
      ) : (
        <p className="convocacao-category-empty mb-0">Nenhum critério disponível no momento.</p>
      )}
    </section>
  </div>
);

const SeguimentoCategorias = ({ categorias, onCategoryChange }) => {
  const coloItems = Array.isArray(categorias?.colo) ? categorias.colo : [];
  const mamaItems = Array.isArray(categorias?.mama) ? categorias.mama : [];
  const [activeCategoryId, setActiveCategoryId] = useState(null);

  const handleCategoryClick = useCallback((id) => {
    setActiveCategoryId((prev) => (prev === id ? null : id));
    onCategoryChange((activeCategoryId === id) ? null : id);
  }, [activeCategoryId, onCategoryChange]);

  return (
    <div className="card mb-3 convocacao-card-shell convocacao-categories-shell">
      <div className="card-body convocacao-categories-body">
        <div className="convocacao-categories-header">
          <h5 className="mb-1">Prioridade da Convocação</h5>
          <p className="mb-0">Selecione o grupo de pacientes para convocar.</p>
        </div>
        <div className="row g-3">
          {renderBlock(
            "Repetir citologia",
            buildColoColumns(coloItems),
            activeCategoryId,
            handleCategoryClick,
          )}
          {renderBlock(
            "Mamografia",
            buildMamaColumns(mamaItems),
            activeCategoryId,
            handleCategoryClick,
          )}
        </div>
      </div>
    </div>
  );
};

SeguimentoCategorias.propTypes = {
  onCategoryChange: PropTypes.func,
  categorias: PropTypes.shape({
    colo: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ),
    mama: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};

SeguimentoCategorias.defaultProps = {
  onCategoryChange: () => {},
};

export default SeguimentoCategorias;
